import { TextField } from '@mui/material';
import useIsViewport from 'hooks/useIsViewport';
import { DisabledFieldTooltip } from '../DisabledFieldTooltip';
import { UnsavedAdornment } from '../UnsavedIcon';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function DefaultTextField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  isUnsaved,
  autoFocus,
  onChange,
}: FieldRendererProps) {
  const isMobile = useIsViewport('md');

  const hasDisabledTooltip = isMobile && isDisabled;
  const endAdornment =
    isUnsaved || hasDisabledTooltip ? (
      <>
        {isUnsaved && <UnsavedAdornment />}
        {hasDisabledTooltip && <DisabledFieldTooltip variant="adornment" title={field.value || ''} />}
      </>
    ) : undefined;

  const textField = (
    <TextField
      variant="outlined"
      className={className}
      sx={getFieldControlSx(hasWhiteFields, sx)}
      margin="dense"
      autoFocus={autoFocus}
      disabled={isDisabled}
      fullWidth
      slotProps={{
        htmlInput: { readOnly: isReadOnly },
        input: { endAdornment },
      }}
      id={field.id.toString()}
      type={field.type}
      label={field.label}
      required={field.required}
      value={field.value}
      onChange={(event) => onChange(event.target.value || '')}
    />
  );

  if (!isMobile && isDisabled) {
    return (
      <DisabledFieldTooltip variant="desktop" title={field.value || ''}>
        {textField}
      </DisabledFieldTooltip>
    );
  }

  return textField;
}
